import toast from 'react-hot-toast'
import { TiWarning } from "react-icons/ti";

const error = (message) => {
    return toast.error(message, {
        style: {
            background: '#ff0000',
            color: '#ffffff',
            padding: '20px',
        },
    })
}

/**
 * RS-22602 Error loading toast
 * @param {*} message message to display
 * @returns toast ID
 */
const errorLoading = (message) => {
    return toast.loading(message, {
        style: {
            background: '#ff0000',
            color: '#ffffff',
            padding: '20px',
        },
    })
}


/**
 * RS-26602 Warning toast
 * @param {*} message message to display
 * @returns toast ID
 */
const warning = (message) => {
    return toast.error(message, {
        style: {
            background: '#ffaa00',
            color: '#ffffff',
            padding: '20px',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#ffaa00',
        },
    })
}

/**
 * RS-26602 Warning loading toast
 * @param {*} message message to display
 * @returns toast ID
 */
const warningLoading = (message) => {
    return toast.loading(message, {
        id: 'warningLoading',
        style: {
            background: '#ffaa00',
            color: '#ffffff',
            padding: '20px',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#ffaa00',
        },
    })
}

const success = (message) => {
    return toast.success(message, {
        style: {
            background: '#00cc00',
            color: '#ffffff',
            padding: '20px',
        },
    })
}

const dismiss = (toastId) => {
    toast.dismiss(toastId)
}

const custom = (c) => {
    return toast.custom(c)
}

const loading = (message) => {
    return toast.loading(message)
}

const sessionJoinRequest = (userFullName, allowJoin, refuseEntry) => {
    return toast.custom((t) => (
        <div
          className={`${
            t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md bg-green-500 rounded flex`}
        >
          <div className="flex-1 max-w-none p-5">
            <div className="flex items-center">
              <div><TiWarning className="h-8 w-8 text-white" aria-hidden="true" /></div>
              <div className="ml-3 text-white white-space-nowrap">
                {userFullName} wants to join the session
              </div>
            </div>
          </div>
          <div className="rounded-lg flex border-l gap-x-px bg-white border-white">
            <button
              onClick={() => {
                allowJoin()
                toast.dismiss(t.id)
            }}
              className="w-full bg-green-500 border border-transparent p-4 flex items-center justify-center text-white font-medium focus:outline-none focus:ring-0"
            >
              Allow
            </button>
            <button
              onClick={() => {
                refuseEntry()
                toast.dismiss(t.id)
              }}
              className="w-full bg-green-500 border border-transparent rounded-r-lg p-4 flex items-center justify-center text-white font-medium focus:outline-none focus:ring-0"
            >
              Deny
            </button>
          </div>
        </div>
      ), {
        duration:Infinity
      })
}

const toastApi = {
    error,
    errorLoading,
    warning,
    warningLoading,
    success,
    dismiss,
    custom,
    loading,
    sessionJoinRequest
}

export default toastApi